// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum CreditExposureNotificationStatus {
  NotSent = "NOT_SENT",
  SentWarning = "SENT_WARNING",
  SentExhausted = "SENT_EXHAUSTED",
}
export default CreditExposureNotificationStatus;
